"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const countries_1 = require("@/store/ducks/countries");
const countries_2 = require("@/services/countries");
const capitalize_1 = require("@/utilities/capitalize");
function searchCountriesUseCase() {
    return (dispatch) => {
        dispatch((0, countries_1.getCountries)());
        return (0, countries_2.getCountries)()
            .then((countries) => {
            const sortedCountries = countries
                .map((country) => {
                return {
                    ...country,
                    name: (0, capitalize_1.capitalize)(country.name, true),
                };
            })
                .sort((a, b) => {
                return a.name.localeCompare(b.name);
            });
            dispatch((0, countries_1.getCountriesSuccess)(sortedCountries));
        })
            .catch(() => {
            dispatch((0, countries_1.getCountriesError)());
        });
    };
}
exports.default = searchCountriesUseCase;
